import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Event as RouterEvent, NavigationEnd, Router } from "@angular/router";
import { AppData, IdentityService } from "./shared/bundles/services.bundle";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { DateParserFormatter } from "./shared/formatters/date-parser-formatter";

@Component({
    selector: "app-root",
    providers: [{ provide: NgbDateParserFormatter, useClass: DateParserFormatter }],
    template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
    constructor(
        private readonly router: Router,
        private readonly titleService: Title,
        private readonly identityService: IdentityService,
        private readonly appData: AppData
    ) {
    }

    ngOnInit() {
        // Title Change
        this.router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationEnd) {
                let root = this.router.routerState.snapshot.root;

                while (root) {
                    if (root.children && root.children.length) {
                        root = root.children[0];
                    } else if (root.data && root.data["title"]) {
                        this.titleService.setTitle(root.data["title"] + " | Measures Manager");
                        return;
                    } else {
                        return;
                    }
                }
            }
        });

        // Account and LoggedIn Status
        this.identityService.get().subscribe(account => {
            if (account) {
                this.appData.setAccount(account);
            }
        });
    }
}